import {CPSConstants} from "commonUtils/enumerations";

export const reportDialogStyle = {
  iconButtonCloseIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    position: "absolute",
    right: "0.5rem",
    top: "0.5rem",
    color: "#233274",
  },
  dataGridStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDataGrid-columnHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
    },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "bold",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
    },
  },
  dialogTitleStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    m: "0rem",
    p: "1.2rem 2rem 0",
    fontSize: CPSConstants.FONTREMHEAD,
    fontWeight: "bold",
    bgcolor: "white",
  },
};
